import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

// Wraps an ADMIN-only /admin/* sub-page so every one of them has a way back to the /admin overview
// (previously only Pricing had a "← Admin" link, and the overview itself had no nav entry).
export default function AdminPage({ children }: { children: ReactNode }) {
  return (
    <>
      <div className="container mx-auto px-4 pt-4">
        <Link to="/admin" className="text-sm text-blue-600 dark:text-blue-400 hover:underline">&larr; Admin</Link>
      </div>
      {children}
    </>
  )
}
